import { ReactNode } from 'react'
import {
  Heading,
  useColorModeValue,
  Box,
  Center,
  BoxProps,
} from '@chakra-ui/react'

interface Props extends BoxProps {
  title?: string | ReactNode | ReactNode[] | null
  footer?: string | ReactNode
  children?: ReactNode
}

export function ContainerAuthentication({
  title = '',
  footer = '',
  children,
  ...rest
}: Props) {
  return (
    <Center
      padding={{ base: 5, md: 10, lg: 16 }}
      flexDirection="column"
      {...rest}
    >
      <Box
        boxSize={{ base: 'xs', sm: 'sm', md: 'md', lg: 'lg' }}
        h="max-content !important"
        bg={useColorModeValue('white.400', 'black.400')}
        rounded="16px"
        boxShadow="lg"
        {...rest}
        p={{ base: 5, md: 10 }}
      >
        {title && (
          <Heading fontSize="4xl" fontWeight="normal" textAlign="center" mb="8">
            {title}
          </Heading>
        )}

        {children}
      </Box>
      {footer && (
        <Box py="5" fontSize="sm">
          {footer}
        </Box>
      )}
    </Center>
  )
}
